import { render, staticRenderFns } from "./blogAd.vue?vue&type=template&id=5cc5c4b0&scoped=true&"
import script from "./blogAd.vue?vue&type=script&lang=js&"
export * from "./blogAd.vue?vue&type=script&lang=js&"
import style0 from "./blogAd.vue?vue&type=style&index=0&id=5cc5c4b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc5c4b0",
  null
  
)

export default component.exports